import classnames from 'classnames'
import React from 'react'

import { IconWithTextfeatureProps } from '@src/quince-components/src/atoms/iconWithTextfeature/IconWithTextfeature'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import RichText from '@src/quince-site-common/src/domains/RichText'
import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'
import ProductPageSectionProps from '@src/quince-site-pdp/src/domains/ProductPageSectionProps'

import { checkIsNewLongFormSectionHidden, getSectionDetailsForDevices } from '../../../helper/product.helper'
import { makeButtonProps } from '../../../molecules/newLongFormModuleCTA'

import FeatureSection from './featureSection'
import { isTextBlockWithIconRowSectionDataValid } from './textBlockWithIconRowSection.helpers'
import styles from './textBlockWithIconRowSection.module.scss'

function TextBlockWithIconRowSection(props: ProductPageSectionProps | BundlePageSectionProps) {
  const product = 'bundle' in props ? props.bundle : props.product
  const { desktopSectionDetails, mobileSectionDetails } = getSectionDetailsForDevices(
    product,
    CUSTOM_SECTION_TYPE.TEXT_BLOCK_WITH_ICON_ROW,
  )

  const isSectionHiddenDesktop =
    isTextBlockWithIconRowSectionDataValid(desktopSectionDetails) &&
    checkIsNewLongFormSectionHidden(desktopSectionDetails)
  const isSectionHiddenMobile =
    isTextBlockWithIconRowSectionDataValid(mobileSectionDetails) &&
    checkIsNewLongFormSectionHidden(mobileSectionDetails)

  return (
    <>
      {desktopSectionDetails && !isSectionHiddenDesktop && (
        <div className="desktopOnly">{renderSection(desktopSectionDetails)}</div>
      )}
      {mobileSectionDetails && !isSectionHiddenMobile && (
        <div className="mobileOnly">{renderSection(mobileSectionDetails)}</div>
      )}
    </>
  )
}

const renderSection = (sectionDetails: CustomSection) => {
  const classNames = sectionDetails?.classNames
  const iconsWithTextDesktop: IconWithTextfeatureProps[] = (sectionDetails?.subSections || []).map(pss => ({
    iconProps: {
      title: pss?.images && pss?.images?.length > 0 ? pss?.images[0]?.title || '' : '',
      url: pss?.images && pss?.images?.length > 0 ? `https:${pss?.images[0]?.url}` : '',
      className: styles.icon,
    },
    heading: pss.displayTitle || '',
    description: RichText.makeRichTextProps(pss.richTexts ? pss.richTexts[0] : undefined),
    button: makeButtonProps(pss.buttons?.[0]),
  }))

  const layoutType = sectionDetails?.layoutType

  return (
    <FeatureSection
      className={classnames(classNames, styles.textBlockWithIconRowSection)}
      heading={sectionDetails?.displayTitle || ''}
      contents={iconsWithTextDesktop}
      layoutType={layoutType}
    />
  )
}

export default TextBlockWithIconRowSection
